import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import {
  Avatar,
  Chip,
  Menu,
  MenuItem,
} from '@mui/material';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import i18n from 'FRONTEND/utils/i18n';
import { DROPDOWN_ARROW_ANIMATION_TRANSITION } from 'LEGACY/constants';

/**
 * Dropdown located in the navbar containing user profile, term and conditions and logout buttons.
 */
const ProfileDropdown = ({
  items,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const currentUser = useSelector((state) => state.user);

  const initials = currentUser.lastName ? `${currentUser.firstName.charAt(0)}${currentUser.lastName.charAt(0)}` : currentUser.firstName.charAt(0);

  const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className='profile_dropdown'>
      <Chip
        avatar={currentUser.picture ? <Avatar src={currentUser.picture} /> : <Avatar>{initials}</Avatar>}
        label={
          <KeyboardArrowDownIcon
            fontSize='small'
            sx={{
              mt: 1,
              transform: `rotate(${anchorEl ? 180 : 0}deg)`,
              transition: DROPDOWN_ARROW_ANIMATION_TRANSITION,
            }}
          />
        }
        onClick={handleAvatarClick}
      />
      <Menu
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        disableAutoFocusItem
      >
        <MenuItem disabled>
          {currentUser.alias}
        </MenuItem>
        {
          items.map(({ label, href, pjax, blank, className }) => (
            href &&
              <MenuItem
                key={label}
                component='a'
                onClick={handleMenuClose}
                href={href}
                data-pjax={pjax}
                target={blank ? '_blank' : '_self'}
                rel={blank ? 'noopener noreferrer' : null}
                className={className}
              >
                {i18n._(label)}
              </MenuItem>
          ))
        }
      </Menu>
    </div>
  );
};

export default ProfileDropdown;
